import { render, staticRenderFns } from "./TooltipIconButton.vue?vue&type=template&id=53d362a1"
import script from "./TooltipIconButton.vue?vue&type=script&lang=js"
export * from "./TooltipIconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports